import React, { memo, useCallback } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { InputField } from '../../../../formFields';
export const SearchInput = memo(({ id, placeholder, value, onChange }) => {
    const handleOnSearchChange = useCallback((event) => {
        onChange(event.target.value);
    }, [onChange]);
    return (React.createElement(InputField, { id: id, customStartAdornment: React.createElement(SearchIcon, { fontSize: "small" }), placeholder: placeholder, value: value, onChange: handleOnSearchChange, role: "searchbox", fullWidth: true }));
});
//# sourceMappingURL=SearchInput.js.map